import { Category } from 'helpCenter/types'
import { authorizedGet } from '.'
export type GetCategoryProps = {
  categoryId: string
}

export async function getCategory({
  categoryId,
}: GetCategoryProps): Promise<Category> {
  try {
    const response = await authorizedGet({
      endpoint: `categories/${categoryId}`,
    })
    const category = (await response.json()) as Category
    return category
  } catch (e) {
    throw e
  }
}
